export const zone = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        zone: 'Zone',
        create_zone:'Create Zone',
        zone_name:'Zone Name',
        zone_status: 'Zone Status',
        add_zone: 'Add Zone',
        edit_zone: 'Edit Zone',
        zone_management:'Zone Management',
        zone_information: 'Zone Information',
        add:{
			success:'Zone added successfully',
			error:'Unable to add zone. Please try again',
		},
		edit:{
			success:'Zone updated successfully',
			error:'Unable to update zone. Please try again'
		},
		get:{
			error: 'Unable to find the data. Please try again'
		},
    },

    ar: {
        zone: 'المنطقة',
        create_zone:'إنشاء منطقة',
        zone_name:'اسم المنطقة',
        zone_status: 'حالة المنطقة',
        add_zone: 'أضف منطقة',
        edit_zone: 'تحرير المنطقة',
        zone_management:'إدارة المنطقة',
        zone_information: 'معلومات المنطقة',
        add:{
			success:'تمت إضافة المنطقة بنجاح',
			error:'غير قادر على إضافة المنطقة. حاول مرة اخرى',
		},
		edit:{
			success:'تم تحديث المنطقة بنجاح',
			error:'تعذر تحديث المنطقة. حاول مرة اخرى'
		},
		get:{
			error: 'تعذر العثور على البيانات. حاول مرة اخرى'
		},
    }
}